var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskErrandCatLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 4,
    fill: "#7980FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0553 45.0732H34.5189C33.7223 45.0732 33.0742 45.7213 33.0742 46.5179V48.5696H47.5002V46.5179C47.5002 45.7195 46.8521 45.0732 46.0573 45.0732H46.0553Z",
    fill: "#7980FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3003 38.7266V43.6478H35.8435L35.7432 38.8283L44.7269 38.7281V43.6493H46.2701V38.7281C46.2701 37.9314 45.622 37.2852 44.8272 37.2852H35.7436C34.9469 37.2852 34.3007 37.9332 34.3007 38.7281L34.3003 38.7266Z",
    fill: "#7980FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0431 44.3947V16.4221C16.0431 15.6237 16.6912 14.9757 17.4879 14.9757H38.6055C39.404 14.9757 40.0502 15.6237 40.0502 16.4221V35.1892H41.5934L41.5952 16.4221C41.5952 14.7733 40.2525 13.4325 38.6055 13.4325L17.4897 13.4307C15.8409 13.4307 14.5 14.7734 14.5 16.4204V44.3947C14.5 46.0418 15.8427 47.3844 17.4897 47.3844H30.9812V45.8412H17.4897C16.6912 45.8412 16.045 45.1931 16.045 44.3965L16.0431 44.3947Z",
    fill: "#7980FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.282 19.4688H24.5561V24.7429H19.282V19.4688Z",
    fill: "#7980FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.282 27.7705H24.5561V33.0447H19.282V27.7705Z",
    fill: "#7980FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.282 36.0732H24.5561V41.3474H19.282V36.0732Z",
    fill: "#7980FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9448 21.334H36.8139V22.8772H27.9448V21.334Z",
    fill: "#7980FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9448 29.6357H36.8139V31.1789H27.9448V29.6357Z",
    fill: "#7980FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9448 37.9395H30.8719V39.4827H27.9448V37.9395Z",
    fill: "#7980FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskErrandCatLogo);
export default __webpack_public_path__ + "static/media/task-errand-cat-logo.ab26bb8479ce515958743ef9d6ac2d81.svg";
export { ForwardRef as ReactComponent };